export class BaseObject
{
    id: number;
    description: string | null;

    constructor()
    {
        this.id = -1;
        this.description = null;
    }
}